import { Component, OnInit, OnChanges, EventEmitter, Output, Input, HostListener } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CfetBaseComponent, CfetService, UrlUtil, CFETILMEndpointsConstant } from '../../../cfet-core';
import { environment } from './../../../../environments/environment';
// Temporarily Added to show hard coded data
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-customer-eligibility-form',
    templateUrl: './customer-eligibility-form.component.html',
    styleUrls: ['./customer-eligibility-form.component.scss'],
    standalone: false
})

export class CustomerEligibilityFormComponent extends CfetBaseComponent implements OnInit, OnChanges {

  customerEligibility: UntypedFormGroup;
  selectCategory: UntypedFormControl;
  selectRole: UntypedFormControl;
  categoryListArray: any = [];
  roleListArray: any = [];
  categoryValueDefault = { 'value': '', 'text': 'Select' };
  roleVal = { 'value': '', 'text': 'Select' };
  selectedCat = '';
  showCat = true;
  showRoleBoolean = false;
  showConfirmRoleFlag = false;
  selectedRoleVal = '';
  roleOnSelect = '';
  showConfirmCheckFlag = false;
  checkCategoryVal = '';
  checkRoleVal = '';
  responderCategoryresponse = {};
  selectedJobFunctionDetails: any;
  jobfunctionentity: any;
  hideButtonsFlag = true;
  showWorkplaceFlag = false;
  showIneligibilityFlag = false;
  hideWorkplaceFlag = false;
  showWorkplaceSection: boolean;
  showtickicon: boolean;
  stateAndZip: any;
  selectedconfirmVal: any = [];
  manuallyEnteredValues: any;
  getorgProfileInfo: any;
  state: any;
  zipcode: any;
  showLoadingFlag = false;
  showSpinnerFlag = false;
  isPSEAffcode: boolean = false;
  @Output() eligibilitycompletionstatus = new EventEmitter<any>();
  @Output() editSelected = new EventEmitter<any>();
  @Input() signupComplete: boolean;
  @Input() editButtonClicked: boolean;
  selectedJobQuestions: any[];
  messageNote: string;
  showNote: boolean;
  @Output() showCancelModal = new EventEmitter<any>();

  constructor(private cfetService: CfetService,
    private urlUtil: UrlUtil,
    // Temporarily added for hard coded data
    private http: HttpClient) { super(); }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.selectCategory = new UntypedFormControl('', [Validators.required]);
    this.selectRole = new UntypedFormControl('', [Validators.required]);
    this.cfetService.isLandingPage.next(false);
    this.customerEligibility = new UntypedFormGroup({
      selectCategory: this.selectCategory,
      selectRole: this.selectRole
    });
    if (sessionStorage.getItem('orgDetailInfo') && Object.keys(sessionStorage.getItem('orgDetailInfo')).length !== 0) {
      this.isPSEAffcode = JSON.parse(sessionStorage.getItem('orgDetailInfo')).isPSEAffcode;
    }
    this.getEntityList();
    if (sessionStorage.getItem('eligibilityInfo') && Object.keys(sessionStorage.getItem('eligibilityInfo')).length !== 0) {
      const eligibilityInformation = JSON.parse(sessionStorage.getItem('eligibilityInfo'));
      if (eligibilityInformation.action === 'Profile Info') {
        this.showCat = false;
        this.showRoleBoolean = false;
        this.showConfirmRoleFlag = true;
        this.hideButtonsFlag = false;
        this.showIneligibilityFlag = false;
        this.showWorkplaceFlag = false;
        this.selectedRoleVal = eligibilityInformation.selectedRoleVal;
        this.selectedCat = eligibilityInformation.entity;
        this.selectCategory.setValue(eligibilityInformation.entity);
        this.selectedJobFunctionDetails = eligibilityInformation.selectedJobFunctionDetails;
        this.roleListArray = eligibilityInformation.rolelist;
        const eligibilityStatus = {
          'selectedName': eligibilityInformation.eligibilityStatus.selectedName,
          'org_name': eligibilityInformation.eligibilityStatus.selectedName,
          'address': eligibilityInformation.eligibilityStatus.selectedAddress,
          'selectedCity': eligibilityInformation.eligibilityStatus.selectedCity,
          'selectedAddress': eligibilityInformation.eligibilityStatus.selectedAddress,
          'city': eligibilityInformation.eligibilityStatus.selectedCity,
          'selectedStateInWorkplace': eligibilityInformation.eligibilityStatus.selectedStateInWorkplace,
          'state': eligibilityInformation.eligibilityStatus.selectedStateInWorkplace,
          'selectedState': eligibilityInformation.eligibilityStatus.selectedStateInWorkplace.split(':')[1],
          'selectedZip': eligibilityInformation.eligibilityStatus.selectedZipInWorkplace,
          'zipcode': eligibilityInformation.eligibilityStatus.selectedZipInWorkplace,
          'selectedZipInWorkplace': eligibilityInformation.eligibilityStatus.selectedZipInWorkplace,
          'searchedResult': eligibilityInformation.eligibilityStatus.searchResults
        };
        this.checkstateAndZip(eligibilityStatus);
        this.hideWorkplaceFlagSection(true);
        const eligibilityInfo = {
          'editIconSelected': true,
          selectedRoleVal: this.selectedRoleVal,
          entity: this.selectCategory.value,
          eligibilityStatus: eligibilityStatus,
          type: eligibilityInformation.type,
          status: eligibilityInformation.status
        };
        sessionStorage.removeItem('eligibilityInfo');
        this.eligibilitycompletionstatus.emit(eligibilityInfo);
      }
    }
  }

  ngOnChanges() {
    if (this.editButtonClicked) {
      this.showCat = false;
      this.showRoleBoolean = false;
      this.showConfirmRoleFlag = true;
      this.hideButtonsFlag = false;
      this.showIneligibilityFlag = false;
      this.showWorkplaceFlag = true;
    }
  }
  onChangeCategory(event) {
    this.checkCategoryVal = '';
    this.customerEligibility.patchValue({
      selectCategory: event.value
    });
    this.selectedCat = this.selectCategory.value;
    this.roleVal = { 'value': '', 'text': 'Select' };
    if (this.selectCategory.value !== 'Select') {
      this.selectedJobFunctionDetails = [];
      this.jobfunctionentity = this.responderCategoryresponse;
      for (const job in this.jobfunctionentity) {
        if (this.selectCategory.value === job) {
          this.roleListArray = this.jobfunctionentity[job].map(
            jobVal => {
              return {
                value: jobVal.responder_sub_category,
                text: jobVal.responder_sub_category
              };
            }
          );
          this.selectedJobFunctionDetails = this.jobfunctionentity[job].map(
            jobDetails => {
              return {
                'jobCategory': jobDetails.responder_sub_category,
                'note': jobDetails.note,
                'questions': jobDetails.questions,
                'type': jobDetails.type,
                'userType': jobDetails.user_type,
                'subType': jobDetails.subtype,
                'status': jobDetails.status,
                'documents': jobDetails.documents
              };
            }
          );
        }
      }
      this.roleListArray.sort(function (a, b) {
        return a['value'].localeCompare(b['value']);
      });
      this.showCat = false;
      this.showRoleBoolean = true;
    }
  }

  editCategory(e) {
    if (e.key === 'Enter' || e.type === 'click') {
      this.showCat = true;
      this.showRoleBoolean = false;
      this.categoryListArray.forEach(element => {
        if (element.value.toLowerCase() === this.selectedCat.toLowerCase()) {
          this.categoryValueDefault = { 'value': element.value, 'text': element.text };
        }
      });
    }
  }

  @HostListener('document:click', ['$event']) clickout(event) {
    if (event.target.id !== 'select_category' && event.target.id !== 'select_role') {
      this.checkCategoryVal = '';
      this.checkRoleVal = '';
    }
  }

  onChangeRole(event) {
    let index = 0;
    this.customerEligibility.patchValue({
      selectRole: event.value
    });
    this.selectedRoleVal = this.selectRole.value;
    this.roleOnSelect = this.selectRole.value.toLowerCase();
    this.showRoleBoolean = false;
    this.checkRoleVal = '';
    this.showConfirmRoleFlag = true;
    this.showConfirmCheckFlag = false;
    this.showWorkplaceFlag = false;
    this.selectedJobQuestions = [];
    this.selectedconfirmVal = [];
    if (this.selectedRoleVal !== 'Select') {
      this.selectedJobFunctionDetails.forEach(job => {
        if (this.roleOnSelect === job.jobCategory.toLowerCase()) {
          job.questions.forEach(ques => {
            this.selectedJobQuestions.push({ 'questionValue': ques, 'radioButtonNo': '' });
            index++;
          });
          this.messageNote = job.note;
        }
      });
      if (this.messageNote === '') {
        this.showNote = false;
      } else {
        this.showNote = true;
      }
    }
    this.hideButtonsFlag = true;
  }

  editRole(e) {
    if (!this.showIneligibilityFlag) {
      if (e.key === 'Enter' || e.type === 'click') {
        this.showRoleBoolean = true;
        this.showConfirmRoleFlag = false;
        const editIconSelected = {
          editIconSelected: true
        };
        this.roleVal = { 'value': this.selectedRoleVal, 'text': this.selectedRoleVal };
        this.editSelected.emit(editIconSelected);
      }
    }
  }

  roleConfirmYes(e, idx) {
    if (e.key === 'Enter' || e.type === 'click') {
      this.showIneligibilityFlag = false;
      this.selectedconfirmVal[idx] = 'Yes';
      if (this.selectedJobQuestions.length === this.selectedconfirmVal.length) {
        this.showConfirmCheckFlag = true;
      }
    }
  }

  roleConfirmNo(e, idx) {
    if (e.key === 'Enter' || e.type === 'click') {
      this.showIneligibilityFlag = false;
      this.selectedconfirmVal[idx] = 'No';
      if (this.selectedJobQuestions.length === this.selectedconfirmVal.length) {
        this.showConfirmCheckFlag = true;
      }
    }
  }

  getOrgInfo() {
    if (sessionStorage.getItem('orgDetailInfo') && Object.keys(sessionStorage.getItem('orgDetailInfo')).length !== 0) {
      this.getorgProfileInfo = JSON.parse(sessionStorage.getItem('orgDetailInfo'));
      this.checkstateAndZip(this.getorgProfileInfo);
      const eligibilitystatus = {
        completionStatus: this.showtickicon
      };
      this.hideButtonsFlag = false;
      this.hideWorkplaceFlagSection(true);
      this.eligibilitycompletionstatus.emit(eligibilitystatus);
    }
  }

  confirmCheckbox(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      let confirmvalue = true;
      if (this.selectedconfirmVal && this.selectedconfirmVal.length > 0) {
        this.selectedconfirmVal.forEach(element1 => {
          confirmvalue = (element1 === 'No') ? false : true;
        });
      }
      if (confirmvalue === true) {
        if (this.showConfirmCheckFlag === true) {
          this.hideButtonsFlag = false;
          this.showWorkplaceFlag = true;
          this.getOrgInfo();
        }
        this.hideWorkplaceFlagSection(event);
      } else {
        this.showIneligibilityFlag = true;
      }
    }
  }

  showLoadingFlagSpinner(event) {
    this.showSpinnerFlag = event;
  }

  hideWorkplaceFlagSection(event) {
    if (event !== undefined) {
      this.hideWorkplaceFlag = event;
    }
    if (this.hideWorkplaceFlag === true) {
      this.hideButtonsFlag = false;
      this.showWorkplaceFlag = true;
      this.showWorkplaceSection = false;
      this.showtickicon = true;
    }
  }

  checkstateAndZip(event) {
    if (event !== undefined && event.state && event.zipcode && event.state !== '') {
      this.manuallyEnteredValues = {};
      this.stateAndZip = event;
    }
  }

  saveManualValues(event) {
    if (event !== undefined) {
      this.manuallyEnteredValues = event;
    }
  }

  onClickCategory(event) {
    this.checkCategoryVal = ((event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) ||
    (event.target.ariaExpanded === 'true')) ? 'dropdown-opened' : '';
  }

  onClickRole(event) {
    this.checkRoleVal = ((event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) ||
      (event.target.ariaExpanded === 'true')) ? 'dropdown-opened' : '';
  }

  getEntityList() {
    this.showLoadingFlag = true;
      this.cfetService.cfetLiveGet('', CFETILMEndpointsConstant.ENTITY_LIST_V2).subscribe((data: any) => {
        this.addFirstResponderCategoriesList(data);
      }, (_error) => {
        this.showLoadingFlag = false;
      });
  }

  addFirstResponderCategoriesList(data: any) {
    if (data && data.firstRespondersCategories) {
      this.showLoadingFlag = false;
      this.responderCategoryresponse = data.firstRespondersCategories[0];
      for (const entity in this.responderCategoryresponse) {
        if (Array.isArray(this.responderCategoryresponse[entity]) ||
          typeof this.responderCategoryresponse[entity] === 'object') {
          this.categoryListArray.push({
            'value': entity,
            'text': entity
          });
        }
      }
      this.categoryListArray.sort(function (a, b) {
        return a['value'].localeCompare(b['value']);
      });
    }
  }

  onEligibilityCompletion(event) {
    let eligibilityStatus = event.manualEntry ? event.eligibilityStatus : event ;

    const eligibilityInfo = {
      selectedRoleVal: this.selectedRoleVal,
      entity: this.selectCategory.value,
      eligibilityStatus: eligibilityStatus,
      action: 'eligibility'
    };
    eligibilityInfo['selectedJobFunctionDetails'] = this.selectedJobFunctionDetails;
    this.selectedJobFunctionDetails.forEach(element => {
      if (element.jobCategory === this.selectedRoleVal) {
        eligibilityInfo['type'] = element.type;
        eligibilityInfo['userType'] = element.userType;
        eligibilityInfo['subType'] = element.subType;
        eligibilityInfo['status'] = element.status;
        eligibilityInfo['documents'] = element.documents;
        eligibilityInfo['questions'] = element.questions;
        eligibilityInfo['note'] = element.note;
      }
    });
    eligibilityInfo['rolelist'] = this.roleListArray;
    sessionStorage.setItem('eligibilityInfo', JSON.stringify(eligibilityInfo));
    this.eligibilitycompletionstatus.emit(eligibilityInfo);
  }

  onEditSelection(event) {
    this.editSelected.emit(event);
  }

  displayCancelModal(event) {
    if (event) {
      this.showCancelModal.emit(true);
    }
  }
}